
  import paycoUtils from "@/assets/js/utils";

  import {defineComponent} from 'vue';
  import {mapGetters, mapMutations, mapState} from "vuex";

  import PopupComponent from '@/components/shared/PopupComponent.vue';
  import store from "@/store";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import Receiver from "@/domain/receiver/Receiver";
  import Product from "@/domain/product/Product";

  export default defineComponent({
    name: 'WriteMessage',
    props:[
        'isForPresent'
    ],
    components: {
      HeaderComponent,
      PopupComponent
    },
    mounted() {
      store.dispatch('ReceiverStore/fetchMaximumGiftCount', this.product.productId);
      if (!this.isForPresent) {
        store.dispatch('ReceiverStore/sendToMe');
      }
      this.message = this.savedMessage;
    },
    beforeUnmount(): void {
      this.setMessage(this.message);
    },
    data() {
      return {
        message: "",
        maxMessageRows: 5,
        maxMessageLength: 100,
        showDeletingPopup: false,
        indexPendingDeletion: -1,

        isTypingMode: false,
      }
    },
    computed: {
      messageLength(): number {
        return this.message.length;
      },
      ...mapState({
        product: (state: any) => new Product(state.ProductStore.product),
        receivers: (state: any) => state.ReceiverStore.receivers.map((receiver: Receiver) => new Receiver(receiver)),
        savedMessage: (state: any) => state.ReceiverStore.message
      }),
      ...mapGetters('ReceiverStore', [
          'sumOfGiftCount',
          'isDecreasable',
          'isIncreasable',
          'hasReceiver'
      ]),
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
      totalPrice(): number {
        return this.product.salePrice * this.sumOfGiftCount;
      },
      commaTotalPrice(): string {
        return paycoUtils.numWithCommas(this.totalPrice + "");
      },
    },
    methods: {
      limit(): void {
        var rows = this.message.split('\n').length;
        if (rows > this.maxMessageRows) {
          let modifiedText = this.message.split("\n").slice(0, this.maxMessageRows);
          this.message = modifiedText.join("\n");
        }

        if (this.messageLength > this.maxMessageLength) {
          this.message = this.message.substring(0, this.maxMessageLength);
        }
      },
      goToOrderSheet(): void {
        if (this.isForPresent) {
          router.push(new NamedRouting('ProductOrderForPresent'));
        } else {
          router.push(new NamedRouting('ProductOrderForPurchase'));
        }
      },
      askIfDelete(receiverIndex: number): void {
        this.indexPendingDeletion = receiverIndex;
        this.toggleDeletingPopup();
      },
      confirmDeletion(isConfirmed: boolean): void {
        if (isConfirmed) {
          this.removeReceiver(this.indexPendingDeletion);
          if (!this.hasReceiver) {
            router.replace({name: 'ReceiverSelection'});
          }
        }
        this.indexPendingDeletion = -1;
        this.toggleDeletingPopup();
      },
      toggleDeletingPopup(): void {
        this.showDeletingPopup = !this.showDeletingPopup;
      },
      ...mapMutations('ReceiverStore', [
          'removeReceiver',
          'increaseGiftCount',
          'decreaseGiftCount',
          'setMessage',
      ]),
      setTypingMode(typingMode: boolean): void {
        this.isTypingMode = typingMode;
      },
    }
  })
